<template>
  <div>
    <h1 class="title has-text-centered is-size-1 has-text-weight-light">
      {{ $t('index.administrating_objects') }}
      <span @click="loadData" :class="{ 'fa-spin': isloading }" style="cursor: pointer" class="has-text-info icon is-large">
        <i class="fas fa-sync"></i>
      </span>
    </h1>
    <b-loading :is-full-page="true" :active.sync="isloading" :can-cancel="false"></b-loading>
    <div class="columns is-multiline" v-if="initResponse.canAdminGlobal">
      <div class="column is-10 is-offset-1 is-narrow" v-for="(object, index) in initResponse.objects" v-if="object.canAdmin" :key="index" :selected="index === 0">
        <article class="tile is-child box">
          <p class="is-size-2 has-text-weight-light">
            <span>{{ object.name }}</span>
          </p>

          <template v-if="object.tariffData.maxConfigs != 999999">
            <!-- <p class="is-size-4 has-text-weight-light">License {{object.tariffData.name}} (used: {{object.tariffData.inUseConfigs}}/{{object.tariffData.maxConfigs}} rooms)</p> -->
            <p class="is-size-4 has-text-weight-light">
              {{ $t('index.license_info_' + object.byod_type, { license: object.tariffData.name, rooms: object.tariffData.inUseConfigs, roomstotal: object.tariffData.maxConfigs }) }}
            </p>
          </template>
          <template v-else>
            <p class="is-size-4 has-text-weight-light">License {{ object.tariffData.name }} (unlimited rooms)</p>
          </template>

          <br />

          <collapse accordion is-fullwidth>
            <collapse-item v-for="(tag, tagI) in initResponse.projectsAdminData[object.id]" :key="tagI" :title="tagI" class="tab-head-custom">
              <tabs type="tabs is-medium ">
                <tab-pane :label="$t('index.rooms_' + object.byod_type)">
                  <div class="wrap_table">
                    <table class="table is-striped is-fullwidth is-narrow">
                      <tr v-for="(confPropVal, confPropKey) in tag.configurations" :key="confPropKey">
                        <td>
                          <span v-if="!confPropVal.edit">
                            {{ confPropVal.name }}
                          </span>
                          <div class="field" v-if="confPropVal.edit">
                            <p class="control">
                              <input class="input is-primary" @keypress.enter="editConfig(confPropVal, confPropVal.newName)" style="width: 90%" type="text" v-model="confPropVal.newName" :placeholder="$t('index.unique_configuration_name')" />
                              <span class="pointer edit-icon" @click="editConfig(confPropVal, confPropVal.newName)">
                                <i class="fas fa-lg fa-check"></i>
                              </span>

                              <span class="pointer edit-icon" @click="confPropVal.edit = false">
                                <i class="fas fa-lg fa-times-circle"></i>
                              </span>
                            </p>
                          </div>
                          <span class="pointer icon" v-if="!confPropVal.edit" @click="showEditConf(object.id, tagI, confPropVal.id)">
                            <i class="fas fa-pencil-alt"></i>
                          </span>
                        </td>

                        <td>
                          <FDateTime :value="confPropVal.updatedAt" />
                        </td>
                        <td style="">
                          <a class="button is-outlined is-small" @click="showRoomFieldsManager(confPropVal)">
                            <span class="icon is-small">
                              <i class="fa fa-th-list"></i>
                            </span>
                            <span>{{ $t('index.set_fields') }}</span>
                          </a>
                          <a class="button is-outlined is-small" @click="showDeleteRoom(confPropVal)">
                            <span class="icon is-small">
                              <i class="fa fa-times"></i>
                            </span>
                            <span>{{ $t('index.delete') }}</span>
                          </a>

                          <div :class="['modal deleteConfigModal', confPropVal.deletePopup ? 'is-active' : '']" style="text-align: left">
                            <div class="modal-background"></div>
                            <!-- <div class="modal-content">
                              Are you sure want delete configuration
                              <b>{{confPropVal.name}}</b> in {{confPropVal.tag}} tag?
                              <br>
                              <span class="tag  is-danger">All binded keys and devices also will be deleted</span>
                            </div> -->

                            <div class="modal-content">
                              {{ $t('index.delete_configuration_confirm', { confname: confPropVal.name, conftag: confPropVal.tag }) }}
                              <br />
                              <span class="tag is-danger">{{ $t('index.delete_configuration_warning') }}</span>
                            </div>

                            <button class="button is-text" @click="confPropVal.deletePopup = false">{{ $t('index.cancel') }}</button>
                            <button class="button is-danger" @click="deleteConfig(confPropVal)">{{ $t('index.yes') }}</button>
                          </div>
                        </td>
                      </tr>
                      <tr>
                        <td v-if="tag.newConfigInputShow">
                          <div class="field">
                            <div class="control">
                              <input class="input is-primary" @keypress.enter="addNewConfig(object.id, tagI)" type="text" v-model="tag.newConfigInputText" :placeholder="$t('index.unique_configuration_name')" />
                            </div>
                          </div>
                        </td>
                        <td v-if="tag.newConfigInputShow">
                          <span class="pointer" @click="addNewConfig(object.id, tagI)">
                            <i class="fa fa-lg fa-check"></i>
                          </span>

                          <span class="pointer" @click="tag.newConfigInputShow = false">
                            <i class="fa fa-lg fa-times-circle"></i>
                          </span>
                        </td>
                      </tr>
                    </table>
                  </div>

                  <a v-if="!tag.newConfigInputShow" class="button is-info is-small" @click="showNewConfigInput(object, tagI, tag)">
                    <span class="icon is-small">
                      <i class="fa fa-plus"></i>
                    </span>
                    <span>{{ $t('index.add_new') }}</span>
                  </a>
                </tab-pane>
                <tab-pane :label="$t('index.projects')">
                  <div class="wrap_table">
                    <table class="table is-striped is-fullwidth">
                      <tr v-for="(tagPropVal, tagPropKey) in tag.projects" :key="tagPropKey">
                        <td>{{ tagPropVal.name }}</td>
                        <td>
                          <FDateTime :value="tagPropVal.updatedAt" />
                        </td>
                      </tr>
                    </table>
                  </div>
                </tab-pane>
              </tabs>
              <section class="has-text-right">
                <button class="button is-default" @click="showFieldsManager(tagI, object.id)">{{ $t('index.fields') }}</button>
              </section>
            </collapse-item>
          </collapse>

          <br />
          <div class="columns">
            <div class="column">
              <b-collapse v-if="object.byod_type !== 'mauth'" :open="false" class="object-collapse">
                <button slot="trigger" class="button">
                  <span class="icon">
                    <i class="fa fa-cog"></i>
                  </span>
                  <span>{{ $t('index.settings') }}</span>
                </button>

                <div class="notification">
                  <div class="content">
                    <div class="columns">
                      <div class="column">
                        <b-field :label="$t('index.default_arrival_time_' + object.byod_type)">
                          <b-timepicker hour-format="24" v-model="object.defArrivalTime" placeholder="Type or select a time..." icon="clock" :readonly="false"> </b-timepicker>
                        </b-field>
                      </div>

                      <div class="column">
                        <b-field :label="$t('index.default_departure_time_' + object.byod_type)">
                          <b-timepicker hour-format="24" v-model="object.defDepartureTime" placeholder="Type or select a time..." icon="clock" :readonly="false"> </b-timepicker>
                        </b-field>
                      </div>
                    </div>
                    <div class="columns">
                      <div class="column">
                        <b-switch v-model="object.showQrCode" type="is-success">
                          {{ $t('index.show_qr_after_reg') }}
                        </b-switch>
                      </div>
                      <div class="column">
                        <b-switch v-model="object.multyTokensConfig" type="is-success"> Multiple tokens in one configuration </b-switch>
                      </div>
                    </div>
                    <div class="columns">
                      <div class="column">
                        <b-field :label="$t('index.def_check_frequency')">
                          <b-input type="number" min="1" max="7" icon="clock" :placeholder="$t('index.days')" v-model="object.defFrequencyCheckPeriod" />
                        </b-field>
                      </div>
                      <div class="column">
                        <b-field :label="$t('index.def_activation_panels_limit')">
                          <b-input :placeholder="$t('index.activation_panels_limit_placeholder')" type="number" min="1" icon="clock" v-model="object.defActivationsCount" />
                        </b-field>
                      </div>
                    </div>

                    <br />
                    <br />
                    <b-loading :is-full-page="false" :active.sync="uploadInProcess" :can-cancel="false"></b-loading>
                    <b-field :label="$t('index.import_settings_from_csv')">
                      <b-field>
                        <b-upload accept=".csv" v-model="file" :loading="uploadInProcess">
                          <a class="button is-info is-right">
                            <b-icon icon="upload"></b-icon>
                            <span>{{ $t('index.upload_file') }}</span>
                          </a>
                        </b-upload>
                        <span class="file-name" v-if="file.name">
                          {{ file.name }}
                        </span>
                      </b-field>
                    </b-field>

                    <div class="buttons has-addons">
                      <button v-if="file.name" class="button" @click="upload(object)">upload</button>
                      <a class="button is-text" target="_blank" download href="https://s3.amazonaws.com/licensetext/import_template.csv">{{ $t('index.download_csv_template') }}</a>
                    </div>

                    <br />
                    <div class="buttons is-right">
                      <button class="button is-success" @click="saveSettings(object)">
                        <span class="icon">
                          <i class="fa fa-check"></i>
                        </span>
                        <span>{{ $t('index.save') }}</span>
                      </button>
                    </div>
                  </div>
                </div>
              </b-collapse>
              <b-collapse v-if="object.byod_type == 'mauth'" :open.sync="object.sms.collapse" class="object-collapse" @open="loadSMS(object)">
                <button slot="trigger" class="button">
                  <span class="icon">
                    <i class="fa fa-phone"></i>
                  </span>
                  <span>{{ $t('index.object_settings.sms_label') }}</span>
                </button>
                <div class="notification">
                  <div class="content">

                    <div class="columns">
                      <div class="column">
                        <b-field label="СМС-провайдер">
                          <div class="select">
                            <select v-model="object.sms.provider" @change="changeProvider(object)">
                              <option value="smsgorod">smsgorod.ru</option>
                              <option value="smsc">smsc.ru</option>
                            </select>
                          </div>
                        </b-field>
                      </div>
                    </div>

                  <section v-if="object.sms.provider == 'smsc'" key="smsc">
                    <div class="columns">
                      <div class="column">
                        <b-field :label="$t('index.object_settings.sms_login')"
                            v-bind:type="{'is-danger': !object.sms.credentials.login || !object.sms.balance }"
                            :message="{ [$t('index.profile.errors.fill_this_field')]: !object.sms.credentials.login }">
                            <b-input type="text"
                                v-model="object.sms.credentials.login">
                            </b-input>
                        </b-field>
                      </div>
                    </div>
                    <div class="columns">
                      <div class="column">
                        <b-field :label="$t('index.object_settings.sms_password')"
                            v-bind:type="{'is-danger': !object.sms.credentials.password || !object.sms.balance }"
                            :message="{ [$t('index.profile.errors.fill_this_field')]: !object.sms.credentials.password }">
                            <b-input type="password" password-reveal
                                v-model="object.sms.credentials.password">
                            </b-input>
                        </b-field>
                      </div>
                    </div>
                    <div class="columns" v-if="object.sms.balance">
                      <div class="column">
                        <b-field :label="$t('index.object_settings.sms_balance')">
                            <b-input
                              type="text"
                              readonly
                              disabled
                              :value="`${object.sms.balance} ₽`">
                            </b-input>
                        </b-field>
                      </div>
                    </div>
                  </section>

                  <section v-if="object.sms.provider == 'smsgorod'" key="smsgorod">
                    <div class="columns">
                      <div class="column">
                        <b-field label="API Key"
                            v-bind:type="{'is-danger': !object.sms.credentials.apiKey || !object.sms.balance}"
                            :message="{ [$t('index.profile.errors.fill_this_field')]: !object.sms.credentials.apiKey }">
                            <b-input type="text"
                                v-model="object.sms.credentials.apiKey">
                            </b-input>
                        </b-field>
                      </div>
                    </div>
                    <div class="columns" v-if="object.sms.balance">
                      <div class="column">
                        <b-field :label="$t('index.object_settings.sms_balance')">
                            <b-input
                              type="text"
                              readonly
                              disabled
                              :value="`${object.sms.balance} ₽`">
                            </b-input>
                        </b-field>
                      </div>
                    </div>
                  </section>

                    <div class="buttons is-right">
                      <button class="button is-primary" @click="testSMS(object)" v-if="object.sms.balance">
                        <span class="icon">
                          <i class="fa fa-comment"></i>
                        </span>
                        <span>{{ $t('index.object_settings.test_sms') }}</span>
                      </button>
                      <button class="button is-success" @click="saveSMS(object)">
                        <span class="icon">
                          <i class="fa fa-check"></i>
                        </span>
                        <span>{{ $t('index.object_settings.save_sms') }}</span>
                      </button>
                      <button v-if="object.sms.balance" class="button is-danger" @click="deleteSMS(object)">
                        <span class="icon">
                          <i class="fa fa-ban"></i>
                        </span>
                        <span>{{ $t('index.object_settings.clear_sms') }}</span>
                      </button>
                    </div>
                    <div class="columns" v-if="object && object.sms && object.sms.open">
                      <div class="column">
                        <b-field :label="$t('index.object_settings.sms_phone')"
                            v-bind:type="{'is-danger': !object.sms.phone }"
                            :message="{ [$t('index.profile.errors.fill_this_field')]: !object.sms.phone }">
                            <b-input type="text"
                                v-model="object.sms.phone">
                            </b-input>
                        </b-field>
                        <button class="button is-warning" @click="sendSMS(object)">
                        <span class="icon">
                          <i class="fa fa-paper-plane"></i>
                        </span>
                        <span>{{ $t('index.object_settings.send_sms') }}</span>
                      </button>
                      </div>
                    </div>
                  </div>
                </div>
              </b-collapse>
            </div>
          </div>
        </article>
      </div>
    </div>

    <b-modal :active.sync="showTagFieldsData" has-modal-card>
      <tagfields @create_room_fields="showRoomFieldsManager" v-bind="tagFieldsData"></tagfields>
    </b-modal>

    <b-modal :active.sync="showRoomFieldsData">
      <roomfields @create_config_fields="showFieldsManagerFromRooms" v-bind="roomFieldsData"></roomfields>
    </b-modal>

    <b-modal :active.sync="showImportedFieldsData" class="config-csv-modal" has-modal-card>
      <importfields @import_fields="successImportFieldsEmit" v-bind="importedFields"></importfields>
    </b-modal>
  </div>
</template>

<script>
import Vue from 'vue';
import Notification from 'vue-bulma-notification';
import { Tabs, TabPane } from 'vue-bulma-tabs';
var moment = require('moment-timezone');
import { Collapse, Item as CollapseItem } from 'vue-bulma-collapse';
import FDateTime from '../mini_components/FDateTime.vue';
import Tagfields from '../mini_components/Tagfields.vue';
import Roomfields from '../mini_components/Roomfields.vue';
import Importfields from '../mini_components/Importfields.vue';

import Buefy from 'buefy';

Vue.use(Buefy, {
  defaultIconPack: 'fas',
});

Vue.use(Buefy);
const NotificationComponent = Vue.extend(Notification);

const openNotification = (
  propsData = {
    title: '',
    message: '',
    type: '',
    direction: '',
    duration: 4500,
    container: '.notifications',
  }
) => {
  return new NotificationComponent({
    el: document.createElement('div'),
    propsData,
  });
};

export default {
  components: {
    Tabs,
    TabPane,
    Collapse,
    CollapseItem,
    Notification,
    FDateTime,
    Tagfields,
    Importfields,
    Roomfields,
  },
  data() {
    return {
      file: {},
      showRightModal: false,
      data: {},
      initResponse: {},
      param: {},
      isloading: false,
      showTagFieldsData: false,
      showRoomFieldsData: false,
      uploadInProcess: false,
      tagFieldsData: {
        objectId: '',
        tagName: '',
        fields: [],
        roomData: false,
      },
      roomFieldsData: {
        roomData: {},
      },
      showImportedFieldsData: false,
      importedFields: {
        objectId: '',
        objName: '',
        fields: [],
        errors: [],
      }
    };
  },
  mounted() {
    this.loadData();
    // Can set query parameter here for auth redirect or just do it silently in login redirect.
  },
  methods: {
    upload(object) {
      var ext = /(?:\.([^.]+))?$/.exec(this.file.name)[1];

      if (this.file.size > 300000) {
        this.openNotificationWithType('danger', 'Upload failed', 'file to big');
        return;
      }

      if (ext !== 'csv') {
        this.openNotificationWithType('danger', 'Upload failed', 'Wrong file format');
        return;
      }

      this.uploadInProcess = true;
      let formData = new FormData();
      formData.append('file', this.file);
      formData.append('objectId', object.id);

      // console.log(this.file);
      Vue.axios
        .post(`${this.$backendHost}/frontend/api/object/settings/upload/csv`, formData, {
          headers: {
            'Content-Type': 'multipart/form-data',
          },
        })
        .then((response) => {
          this.uploadInProcess = false;
          this.importedFields.objectId = object.id;
          this.importedFields.objName = object.name;
          this.importedFields.errors = [];
          this.showImportedFieldsData = true;

          if (response.data.status) {
            this.importedFields.errors = response.data.errors;
          } else {
            this.importedFields.fields = response.data.fields;
          }
        })
        .catch((err) => {
          this.uploadInProcess = false;
          this.openNotificationWithType('danger', '', err);
        });
    },
    handleFileUpload() {
      this.file = this.$refs.file.files[0];
    },
    showFieldsManagerFromRooms(roomData) {
      this.showFieldsManager(roomData.tag, roomData.objectId, roomData);
    },
    successImportFieldsEmit(importData) {
      //this.uploadInProcess = false
      this.loadData(importData.objectId);
    },
    showFieldsManager(tagI, objectId, roomData = false) {
      this.$http({
        method: 'post',
        url: `${this.$backendHost}/frontend/api/tagfields/get`,
        transformResponse: [
          (data) => {
            return JSON.parse(data);
          },
        ],
        data: {
          tagName: tagI,
          objectId: objectId,
        },
      })
        .then((response) => {
          if (response.data.status) {
            // this.openNotificationWithType('danger', '', response.data.error);
            this.openNotificationWithType('danger', '', response.data.error_code ? this.$t(`index.jwt_errors.${response.data.error_code}`) : response.data.error);
          } else {
            this.showTagFieldsData = true;
            this.tagFieldsData = {
              objectId: objectId,
              tagName: tagI,
              fields: response.data.fields,
              roomData: roomData,
            };
            console.log(response.data);
          }
        })
        .catch((error) => {
          this.openNotificationWithType('danger', '', error);
        });
    },
    showRoomFieldsManager(roomData) {
      this.showRoomFieldsData = true;
      this.roomFieldsData = {
        roomData: roomData,
      };
    },
    saveSettings(object) {
      this.$http({
        method: 'post',
        url: `${this.$backendHost}/frontend/api/object/settings/save`,
        transformResponse: [
          (data) => {
            return JSON.parse(data);
          },
        ],
        data: {
          timezone: moment.tz.guess(),
          objectId: object.id,
          defArrivalTime: object.defArrivalTime.getTime(),
          defDepartureTime: object.defDepartureTime.getTime(),
          showQrCode: object.showQrCode,
          multyTokensConfig: object.multyTokensConfig,
          defLimitType: 1,
          defFrequencyCheckPeriod: parseInt(object.defFrequencyCheckPeriod),
          defActivationsCount: parseInt(object.defActivationsCount),
        },
      })
        .then((response) => {
          if (response.data.status) {
            // this.openNotificationWithType('danger', '', response.data.error);
            this.openNotificationWithType('danger', '', response.data.error_code ? this.$t(`index.jwt_errors.${response.data.error_code}`) : response.data.error);
          } else {
            this.loadData();
            console.log(response.data);
            this.openNotificationWithType('success', '', this.$t('index.succesfully_saved'));
          }
        })
        .catch((error) => {
          this.openNotificationWithType('danger', '', error);
        });
    },
    showNewConfigInput(object, tagI, tag) {
      console.log(this.initResponse.projectsAdminData[object.id][tagI]);
      this.$set(this.initResponse.projectsAdminData[object.id][tagI], 'newConfigInputShow', true);
      this.$set(this.initResponse.projectsAdminData[object.id][tagI], 'newConfigInputText', '');
    },
    dateFormat(date) {
      return moment(new Date(date)).format('DD.MM.YYYY');
    },
    timeFormat(date) {
      return moment(new Date(date)).format('hh:mm:ss');
    },
    showDeleteRoom(confObj) {
      this.initResponse.projectsAdminData[confObj.objectId][confObj.tag].configurations.forEach((item, i) => {
        if (item.id == confObj.id) {
          this.$set(this.initResponse.projectsAdminData[confObj.objectId][confObj.tag].configurations[i], 'deletePopup', true);
        }
      });
    },
    showEditConf(objId, tagName, confId) {
      this.initResponse.projectsAdminData[objId][tagName].configurations.forEach((item, i) => {
        if (item.id == confId) {
          this.$set(this.initResponse.projectsAdminData[objId][tagName].configurations[i], 'edit', true);
          this.$set(this.initResponse.projectsAdminData[objId][tagName].configurations[i], 'newName', item.name);
        }
      });
    },
    deleteConfig(confObj) {
      this.$http({
        method: 'post',
        url: `${this.$backendHost}/frontend/api/configurations/destroy`,
        transformResponse: [
          (data) => {
            return JSON.parse(data);
          },
        ],
        data: {
          confId: confObj.id,
          objectId: confObj.objectId,
        },
      })
        .then((response) => {
          if (response.data.status) {
            // this.openNotificationWithType('danger', '', response.data.error);
            this.openNotificationWithType('danger', '', response.data.error_code ? this.$t(`index.jwt_errors.${response.data.error_code}`) : response.data.error);
          } else {

            this.$http({
              method: 'post',
              url: `https://iridi.com/customer/api_byod/?act=delete_config`,
              data: { configId: confObj.id },
            })
              .then((bitixResponse) => {
                if (bitixResponse.data.status != 'success') {
                  this.openNotificationWithType('danger', '', this.$t('index.'+ bitixResponse.data.code));
                }
              })
              .catch((error) => {
                console.log(error);
              });

            this.loadData();
          }
        })
        .catch((error) => {
          this.openNotificationWithType('danger', '', error);
        });
    },
    editConfig(confObj, newName) {
      this.$http({
        method: 'post',
        url: `${this.$backendHost}/frontend/api/configurations/edit`,
        transformResponse: [
          (data) => {
            return JSON.parse(data);
          },
        ],
        data: {
          confId: confObj.id,
          objectId: confObj.objectId,
          values: {
            tag: confObj.tag,
            name: newName,
          },
        },
      })
        .then((response) => {
          if (response.data.status) {
            // this.openNotificationWithType('danger', '', response.data.error);
            this.openNotificationWithType('danger', '', response.data.error_code ? this.$t(`index.jwt_errors.${response.data.error_code}`) : response.data.error);
          } else {
            this.loadData();
          }
        })
        .catch((error) => {
          this.openNotificationWithType('danger', '', error);
        });
    },

    addNewConfig(objectId, tagName) {
      this.$http({
        method: 'post',
        url: `${this.$backendHost}/frontend/api/configurations/add`,
        transformResponse: [
          (data) => {
            return JSON.parse(data);
          },
        ],
        data: {
          objectId: objectId,
          tag: tagName,
          name: this.initResponse.projectsAdminData[objectId][tagName].newConfigInputText,
        },
      })
        .then((response) => {
          if (response.data.status) {
            // this.openNotificationWithType('danger', '', response.data.error);
            this.openNotificationWithType('danger', '', response.data.error_code ? this.$t(`index.jwt_errors.${response.data.error_code}`) : response.data.error);
          } else {
            this.loadData();
          }
        })
        .catch((error) => {
          this.openNotificationWithType('danger', '', error);
        });
    },
    openNotificationWithType(type, title, message) {
      openNotification({
        title: title,
        message: message,
        type: type,
      });
    },
    getRightClass(id) {
      return id === null ? 'blend' : '';
    },
    toggleFormInvite(obj) {
      obj.newRightForm = !obj.newRightForm;
      if (obj.objType === 3) {
        obj.Macros = 0;
        obj.Routines = 0;
        obj.Schedules = 0;
      }
    },
    loadData(objectId) {
      this.isloading = true;

      if(this.initResponse && this.initResponse.objects){
        this.initResponse.objects.forEach((o)=>o.sms.collapse = false)
      }

      this.data.length = 0;
      this.$http({
        method: 'post',
        url: `${this.$backendHost}/frontend/api/init/admin`,
        transformResponse: [
          (data) => {
            return JSON.parse(data);
          },
        ],
        data: {
          objectId: objectId,
        },
      })
        .then((response) => {
          if (response.data.error) {
            // this.openNotificationWithType('danger', '', response.data.error);
            this.openNotificationWithType('danger', '', response.data.error_code ? this.$t(`index.jwt_errors.${response.data.error_code}`) : response.data.error);
          } else {
            response.data.objects.map((o) => {
              o.defArrivalTime = new Date(o.defArrivalTime);
              o.defDepartureTime = new Date(o.defDepartureTime);
              o.sms = {login: '', password: '', phone: '', open: false, collapse: false, balance: null}
              return o;
            });
            this.$set(this, 'initResponse', response.data);
          }
          this.isloading = false;
        })
        .catch((error) => {
          this.isloading = false;
          this.openNotificationWithType('danger', '', error.error || error);
        });
    },
    loadSMS(object){
      this.isloading = true
      this.$http({
        method: 'get',
        url: `${this.$backendHost}/frontend/api/object/sms?objectId=${object.id}`,
      }).then(({data})=>{
        if(data.fields !=null ) {
          object.sms.balance = data.fields.balance
          object.sms.provider = data.fields.provider
          object.sms.credentials = data.fields.credentials
        }
        this.isloading = false
      }).catch(()=>{
        this.isloading = true
      })
    },
    saveSMS(object){
      this.isloading = true
      this.$http({
        method: 'put',
        url: `${this.$backendHost}/frontend/api/object/sms`,
        data: {
          objectId: object.id,
          sms: object.sms
        },
      }).then(({data})=>{
        if(data.fields !=null && data.fields.balance) {
          object.sms.login = data.fields.login
          object.sms.password = data.fields.password
          object.sms.balance = data.fields.balance
          this.openNotificationWithType('success', '', this.$t('index.object_settings.sms_saved_success'))
        } else {
          this.openNotificationWithType('danger', '', this.$t('index.object_settings.sms_saved_error'))
        }
        this.isloading = false

      }).catch(()=>{
        this.isloading = true
      })
    },

    deleteSMS(object){
      this.isloading = true
      this.$http({
        method: 'delete',
        url: `${this.$backendHost}/frontend/api/object/sms`,
        data: {
          objectId: object.id,
        },
      }).then(({data})=>{
        if(data.fields !=null ) {
          object.sms.credentials = {}
          object.sms.balance = ''
        }
        this.isloading = false
        this.openNotificationWithType('success', '', this.$t('index.object_settings.sms_saved_success'))
      }).catch(()=>{
        this.isloading = true
      })
    },
    testSMS(object){
      object.sms.open = true
    },
    changeProvider(object) {
      object.sms.credentials = {}
      object.sms.balance = ''
      this.$forceUpdate()
    },
    sendSMS(object){
      this.isloading = true
      this.$http({
        method: 'post',
        url: `${this.$backendHost}/frontend/api/object/sms`,
        data: {
          objectId: object.id,
          sms: {
            phone: object.sms.phone,
          }
        },
      }).then(({data})=>{
        if(data.fields !=null ) {
          object.sms.balance = data.fields.balance
        }
        this.isloading = false
        object.sms.open = false
        object.sms.phone = ''
        this.openNotificationWithType('success', '', this.$t('index.object_settings.sms_send_success'))
      }).catch(()=>{
        this.isloading = true
      })
    }
  },
};
</script>

<style lang="scss">
.object-collapse {
  margin-bottom: 10px;

  .collapse-content {
    margin-top: 10px;
  }
}

.tab-content {
  margin: 10px 0px !important;
}
tr.blend {
  opacity: 0.3;
}
.tab-head-custom h3 {
  font-size: 1.2rem;
  font-weight: 500;
}
.tab-list a {
  font-size: 1.1rem;
}
.pointer {
  cursor: pointer;
}
</style>

<style lang="scss" >
.icon {
  vertical-align: middle;
}
.wrap_table {
  overflow-x: auto;

  table {
    min-width: 480px;
  }
}
.table td,
.table th {
  vertical-align: middle;
}
.deleteConfigModal {
  padding: 20px;
  .modal-background {
    background-color: #efefef;
  }
}
.styles-box .notification {
  margin-bottom: 20px;
  line-height: 1.25;
}

.blended {
  opacity: 0.3;
}

.pointer {
  cursor: pointer;
}
.edit-icon {
  vertical-align: sub;
}

@media print {
  aside {
    display: none;
  }

  .app-navbar {
    display: none;
  }

  .app-main {
    margin: 0 !important;
    padding: 0;
  }

  .modal-content,
  .modal-card {
    max-height: 100vh;
  }

  .button {
    display: none;
  }
}

@media screen and (max-width: 768px) {
  .modal-card {
    max-height: calc(100vh - 140px) !important;
  }
}

@media screen and (min-width: 768px) {
  .modal-card {
    max-height: calc(100vh - 140px) !important;
  }
}
</style>



// WEBPACK FOOTER //
// index.vue?017e83a2